export const truncateBiChartLabel = (value, maxLength) => {
  if (value === null || value === undefined) return value;

  const label = String(value);
  const parsedMaxLength = Number(maxLength);

  if (!Number.isInteger(parsedMaxLength) || parsedMaxLength <= 0 || label.length <= parsedMaxLength) {
    return label;
  }

  return `${label.slice(0, parsedMaxLength)}...`;
};

export const BI_CHART_TOOLTIP_OPTIONS = {
  backgroundColor: 'rgba(75, 85, 99, 0.95)',
  titleColor: '#ffffff',
  bodyColor: '#ffffff',
  titleFont: {
    size: 11,
    weight: 'normal',
  },
  bodyFont: {
    size: 11,
  },
  padding: 8,
  cornerRadius: 4,
  callbacks: {
    title: (items) => items[0]?.label ?? '',
  },
};

const getTooltipPosition = (chart, x, y, width, height) => {
  const padding = 6;
  const offset = 8;
  const tooltipX = Math.min(Math.max(x - width / 2, padding), chart.width - width - padding);
  const tooltipY = y - height - offset >= padding ? y - height - offset : y + offset;

  return { x: tooltipX, y: tooltipY };
};

export const createBiChartLabelTooltipPlugin = ({ maxLength, categoryAxis, useLegend = false }) => ({
  id: 'biChartLabelTooltip',
  afterEvent: (chart, args) => {
    const { event } = args;
    const parsedMaxLength = Number(maxLength);
    let label = null;

    if (Number.isInteger(parsedMaxLength) && parsedMaxLength > 0 && event.type !== 'mouseout') {
      if (useLegend) {
        const legendHitBoxes = chart.legend?.legendHitBoxes ?? [];
        const labelIndex = legendHitBoxes.findIndex(
          (hitBox) =>
            event.x >= hitBox.left &&
            event.x <= hitBox.left + hitBox.width &&
            event.y >= hitBox.top &&
            event.y <= hitBox.top + hitBox.height
        );

        if (labelIndex >= 0) label = chart.data.labels?.[labelIndex];
      } else {
        const scale = chart.scales?.[categoryAxis];
        const isInsideScale =
          scale &&
          event.x >= scale.left &&
          event.x <= scale.right &&
          event.y >= scale.top &&
          event.y <= scale.bottom;

        if (isInsideScale) {
          const pixel = categoryAxis === 'y' ? event.y : event.x;
          const labelIndex = Math.round(scale.getValueForPixel(pixel));
          label = chart.data.labels?.[labelIndex];
        }
      }
    }

    const fullLabel = label === null || label === undefined ? null : String(label);
    chart.$biChartLabelTooltip =
      fullLabel && fullLabel.length > parsedMaxLength
        ? { text: fullLabel, x: event.x, y: event.y }
        : null;
    args.changed = true;
  },
  afterDraw: (chart) => {
    const tooltip = chart.$biChartLabelTooltip;
    if (!tooltip) return;

    const context = chart.ctx;
    const paddingX = 7;
    const paddingY = 5;

    context.save();
    context.font = '11px sans-serif';

    const textWidth = context.measureText(tooltip.text).width;
    const boxWidth = textWidth + paddingX * 2;
    const boxHeight = 11 + paddingY * 2;
    const position = getTooltipPosition(chart, tooltip.x, tooltip.y, boxWidth, boxHeight);

    context.fillStyle = 'rgba(75, 85, 99, 0.95)';
    context.beginPath();
    context.roundRect(position.x, position.y, boxWidth, boxHeight, 4);
    context.fill();

    context.fillStyle = '#ffffff';
    context.textBaseline = 'middle';
    context.fillText(tooltip.text, position.x + paddingX, position.y + boxHeight / 2);
    context.restore();
  },
});
